import { SimpleEventEmitter } from '@ixfx/events';
import { StateMachineWithEvents } from '@ixfx/flow/state-machine';
//import { type StateChangeEvent } from '../flow/StateMachineWithEvents.js';
import { indexOfCharCode, omitChars } from '@ixfx/core/text';
import { retryFunction } from '@ixfx/flow';
import { Codec } from './codec.js';
import { StringReceiveBuffer } from './string-receive-buffer.js';
import { StringWriteBuffer } from './string-write-buffer.js';
import {} from './types.js';
import { genericStateTransitionsInstance } from './generic-state-transitions.js';
export class JsonDevice extends SimpleEventEmitter {
    states;
    codec;
    verboseLogging = false;
    name;
    connectAttempts;
    chunkSize;
    rxBuffer;
    txBuffer;
    constructor(config = {}) {
        super();
        // Init
        this.verboseLogging = config.debug ?? false;
        this.chunkSize = config.chunkSize ?? 1024;
        this.connectAttempts = config.connectAttempts ?? 3;
        this.name = config.name ?? `JsonDevice`;
        // Transmit buffer
        this.txBuffer = new StringWriteBuffer(async (data) => {
            // When we have data to actually write to device
            // eslint-disable-next-line @typescript-eslint/await-thenable
            await this.writeInternal(data);
        }, config);
        // Receive buffer
        this.rxBuffer = new StringReceiveBuffer((line) => {
            this.fireEvent(`data`, { data: line });
        });
        this.codec = new Codec();
        this.states = new StateMachineWithEvents(genericStateTransitionsInstance, {
            initial: `ready`,
        });
        this.states.addEventListener(`change`, (event) => {
            this.fireEvent(`change`, event);
            this.verbose(`${event.priorState} -> ${event.newState}`);
            if (event.priorState === `connected`) {
                // Clear out buffers
                this.rxBuffer.clear();
                this.txBuffer.clear();
            }
        });
    }
    get isConnected() {
        return this.states.state === `connected`;
    }
    get isClosed() {
        return this.states.state === `closed`;
    }
    write(txt) {
        if (this.states.state !== `connected`) {
            throw new Error(`Cannot write while state is ${this.states.state}`);
        }
        this.txBuffer.add(txt);
    }
    // eslint-disable-next-line @typescript-eslint/require-await
    async close() {
        if (this.states.state !== `connected`)
            return;
        // console.log(`rxBuffer closing`);
        // try {
        //   await this.rxBuffer.close();
        // } catch (e) {
        //   console.warn(e);
        // }
        // console.log(`txBuffer closing`);
        // try {
        //   await this.txBuffer.close();
        // } catch (e) {
        //   console.warn(e);
        // }
        // console.log(`calling onClose`);
        this.onClosed();
    }
    async connect() {
        const attempts = this.connectAttempts;
        this.states.state = `connecting`;
        await this.onPreConnect();
        await retryFunction(async () => {
            await this.onConnectAttempt();
            this.states.state = `connected`;
            return true;
        }, {
            limitAttempts: attempts,
            startAt: 200,
        });
    }
    onRx(event) {
        //const rx = this.rx;
        //if (rx === undefined) return;
        const view = event.target.value;
        if (view === undefined)
            return;
        let string_ = this.codec.fromBuffer(view.buffer);
        // Check for flow control chars
        const plzStop = indexOfCharCode(string_, 19);
        const plzStart = indexOfCharCode(string_, 17);
        // Remove if found
        if (plzStart && plzStop < plzStart) {
            this.verbose(`Tx plz start`);
            string_ = omitChars(string_, plzStart, 1);
            this.txBuffer.paused = false;
        }
        if (plzStop && plzStop > plzStart) {
            this.verbose(`Tx plz stop`);
            string_ = omitChars(string_, plzStop, 1);
            this.txBuffer.paused = true;
        }
        this.rxBuffer.add(string_);
    }
    verbose(m) {
        if (this.verboseLogging)
            console.info(this.name, m);
    }
    log(m) {
        console.log(this.name, m);
    }
    warn(m) {
        console.warn(this.name, m);
    }
}
